var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTalaeraLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "65px",
    viewBox: "0 0 141 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "talaera-logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,34 L21.3215246,20 L35,28.096914 L29.1284679,34 L0,34 Z M20.7323602,23.2986467 L13.762023,27.9598395 L18.6415488,27.9598395 L23.1826197,30.4328822 L22.5184063,27.9598395 L30.9645517,27.9598395 L20.7323602,23.2986467 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.7%",
    y: "-21.4%",
    width: "111.4%",
    height: "128.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86,18.806483 L108.10992,9 L137,33 L98.0514749,33 L86,18.806483 Z M108.43506,12.4285714 L93.0734878,17.90202 L105.171095,17.90202 L103.827052,21 L109.639548,17.90202 L115.036744,17.90202 L108.43506,12.4285714 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.9%",
    y: "-12.5%",
    width: "107.8%",
    height: "116.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33,34 L66.5135135,0 L95,34 L33,34 Z M66.9375406,5.1 L54.7837838,16.4909813 L65.3090464,16.4909813 L64.013252,20.4 L69.8467019,16.4909813 L76.5675676,16.4909813 L66.9375406,5.1 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-8.8%",
    width: "106.5%",
    height: "111.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1653052,45.8506401 L15.9859962,45.8506401 L15.9859962,62.9061166 L10.1482571,62.9061166 L10.1482571,45.8506401 L4,45.8506401 L4,41.3129445 L22.1653052,41.3129445 L22.1653052,45.8506401 Z M35.572784,57.7738265 L28.9898016,57.7738265 L27.7166777,62.9061166 L21.7547313,62.9061166 L27.6235222,42.8463727 C27.7270288,42.3873851 27.959915,42.0170711 28.3221878,41.7354196 C28.6844607,41.4537682 29.1036558,41.3129445 29.5797859,41.3129445 L34.9827997,41.3129445 C35.4589298,41.3129445 35.8781249,41.4537682 36.2403978,41.7354196 C36.6026706,42.0170711 36.8459073,42.3873851 36.9701152,42.8463727 L42.8078543,62.9061166 L36.845908,62.9061166 L35.572784,57.7738265 Z M34.4859709,53.5177809 L33.1196915,47.9786629 C32.8919771,46.8937831 32.7574207,46.1427238 32.7160181,45.7254623 L31.8776194,45.7254623 C31.7327102,46.5182591 31.5878033,47.2693184 31.4428941,47.9786629 L30.0766147,53.5177809 L34.4859709,53.5177809 Z M49.6012989,41.3129445 L49.6012989,56.8662873 C49.6012989,57.7633995 50.0877723,58.2119488 51.0607337,58.2119488 L58.3268558,58.2119488 L58.606322,62.6244666 C56.577594,62.8748234 53.2964862,63 48.7629002,63 C47.1688996,63 45.9371904,62.5670977 45.0677356,61.7012802 C44.1982807,60.8354627 43.7635598,59.6827952 43.7635598,58.2432432 L43.7635598,41.3129445 L49.6012989,41.3129445 Z M73.9597138,57.7738265 L67.3767314,57.7738265 L66.1036075,62.9061166 L60.1416612,62.9061166 L66.0104521,42.8463727 C66.1139586,42.3873851 66.3468448,42.0170711 66.7091177,41.7354196 C67.0713905,41.4537682 67.4905857,41.3129445 67.9667157,41.3129445 L73.3697296,41.3129445 C73.8458596,41.3129445 74.2650548,41.4537682 74.6273276,41.7354196 C74.9896005,42.0170711 75.2328372,42.3873851 75.357045,42.8463727 L81.1947841,62.9061166 L75.2328378,62.9061166 L73.9597138,57.7738265 Z M72.8729007,53.5177809 L71.5066213,47.9786629 C71.278907,46.8937831 71.1443505,46.1427238 71.1029479,45.7254623 L70.2645492,45.7254623 C70.11964,46.5182591 69.9747331,47.2693184 69.8298239,47.9786629 L68.4635446,53.5177809 L72.8729007,53.5177809 Z M97.272718,58.43101 L97.5521843,62.655761 C95.5234563,62.8852548 91.9835861,63 86.9324674,63 C85.4626747,63 84.2827179,62.5775291 83.3925618,61.7325747 C82.5024056,60.8876202 82.0573342,59.7662469 82.0573342,58.3684211 L82.0573342,45.8506401 C82.0573342,44.4528143 82.5075809,43.3314409 83.4080877,42.4864865 C84.3085945,41.641532 85.483376,41.2190612 86.9324674,41.2190612 C91.9835861,41.2190612 95.5234563,41.3338063 97.5521843,41.5633001 L97.272718,45.7880512 L89.2303009,45.7880512 C88.3401447,45.7880512 87.8950733,46.2366005 87.8950733,47.1337127 L87.8950733,49.7624467 L96.1238013,49.7624467 L96.1238013,53.799431 L87.8950733,53.799431 L87.8950733,57.0853485 C87.8950733,57.9824606 88.3401447,58.43101 89.2303009,58.43101 L97.272718,58.43101 Z M118.4811,62.9061166 L112.363895,62.9061166 L110.842356,56.3968706 C110.697447,55.7709784 110.474911,55.3432918 110.174743,55.113798 C109.874574,54.8843042 109.424327,54.769559 108.823989,54.769559 L106.184586,54.769559 L106.184586,62.9061166 L100.440002,62.9061166 L100.440002,41.3129445 C102.46873,41.1043138 105.356519,41 109.103455,41 C112.18795,41 114.382255,41.4746278 115.686438,42.4238976 C116.99062,43.3731674 117.642701,45.0682666 117.642701,47.5092461 C117.642701,50.6804331 116.235034,52.4224735 113.419656,52.7354196 L113.419656,52.9231863 C115.22067,53.2152694 116.317822,54.3209956 116.711147,56.2403983 L118.4811,62.9061166 Z M106.184586,50.4822191 L108.979248,50.4822191 C110.076417,50.4822191 110.816478,50.3048856 111.199452,49.9502134 C111.582426,49.5955411 111.77391,48.9070701 111.77391,47.8847795 C111.77391,46.862489 111.582426,46.1740179 111.199452,45.8193457 C110.816478,45.4646734 110.076417,45.28734 108.979248,45.28734 L106.184586,45.28734 L106.184586,50.4822191 Z M132.76493,57.7738265 L126.181947,57.7738265 L124.908823,62.9061166 L118.946877,62.9061166 L124.815668,42.8463727 C124.919174,42.3873851 125.152061,42.0170711 125.514334,41.7354196 C125.876606,41.4537682 126.295802,41.3129445 126.771932,41.3129445 L132.174945,41.3129445 C132.651075,41.3129445 133.070271,41.4537682 133.432544,41.7354196 C133.794816,42.0170711 134.038053,42.3873851 134.162261,42.8463727 L140,62.9061166 L134.038054,62.9061166 L132.76493,57.7738265 Z M131.678117,53.5177809 L130.311837,47.9786629 C130.084123,46.8937831 129.949566,46.1427238 129.908164,45.7254623 L129.069765,45.7254623 C128.924856,46.5182591 128.779949,47.2693184 128.63504,47.9786629 L127.26876,53.5177809 L131.678117,53.5177809 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-13.6%",
    width: "102.9%",
    height: "118.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-569.000000, -71.000000)",
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(570.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "talaera-logo-white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TALAERA"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalaeraLogoWhite);
export default __webpack_public_path__ + "static/media/talaera-logo-white.0ac1d560b1a74b6c4a4f7d7728405527.svg";
export { ForwardRef as ReactComponent };